import {defineType, PreviewLayoutKey, PreviewProps, Preview} from 'sanity'
import {PiIdentificationCard} from 'react-icons/pi'
import {Flex} from '@sanity/ui'
import {InlineBannerItem} from '@/types/sanity.types'

const InlineBannerPreview = (props: PreviewProps<PreviewLayoutKey>) => {
  const items = ((props as any).items || []) as InlineBannerItem[]
  const schemaType = (props as any).schemaType?.fields?.[0]
  const itemSchemaType = schemaType.type?.of?.[0]

  return (
    <>
      {props.renderDefault({...props, title: 'Inline Banner', media: <PiIdentificationCard />})}
      <Flex align="center" gap={2}>
        {items.map((item, index) => (
          <Preview key={index} schemaType={itemSchemaType} value={item} />
        ))}
      </Flex>
    </>
  )
}

export default defineType({
  type: 'object',
  name: 'inline-banner',
  title: 'Inline Banner',
  icon: PiIdentificationCard,
  components: {
    preview: InlineBannerPreview,
  },
  fields: [
    {
      name: 'items',
      type: 'array',
      title: 'Items',
      of: [{type: 'inline-banner-item'}],
      options: {
        sortable: true,
      },
    },
  ],
  preview: {
    select: {
      items: 'items',
    },
  },
})
